import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col  from 'react-bootstrap/Col';
import { postRequest } from './Services/HttpClient'; 
import './App.css';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';

const Shabdaadhikaaraha = () => {
  const [gridData, setGridData] = useState(
    Array.from({ length: 9 }, () => Array(4).fill(""))
  );
  const [praatipadikam, setPraatipadikam] = useState("");
  const [response, setResponse] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const rowLabels = [
    "प्रथमा विभक्तिः",
    "संबोधन प्रथमा विभक्तिः",
    "द्वितीया विभक्तिः",
    "तृतीया विभक्तिः",
    "चतुर्थी विभक्तिः",
    "पञ्चमी विभक्तिः",
    "षष्ठी विभक्तिः",
    "सप्तमी विभक्तिः"
  ];  

  useEffect(() => {
    document.body.classList.add('shabdaadhikaaraha-bg');

    return () => {
      document.body.classList.remove('shabdaadhikaaraha-bg');
    };
  }, []);
  
  useEffect(() => {
    const initialGridData = gridData.map((row, rowIndex) => {
      if (rowIndex === 0) {
        row[1] =("एकवचनम्"); 
        row[2] = "द्विवचनम्"; 
        row[3] = "बहुवचनम्"; 
      }
      if (rowIndex > 0 && rowIndex <= rowLabels.length) {
        row[0] = rowLabels[rowIndex - 1];
      }
      return row;
    });
    setGridData(initialGridData);
  }, []);  

  const handleSubmit = async () => {
    try {
      const payload = { praatipadikam };
      console.log('Sending Payload:', payload); 
  
      const response = await postRequest('getVibhaktis', JSON.stringify(payload), {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const responseData = await response.json();
      console.log('Parsed Response Data:', responseData);
  
      if (responseData && responseData.data) {
        console.log('Backend Response after Submit:', responseData.data);
        setResponse(responseData.data);
        updateGridData(responseData.data); 
      } else {
        console.error('No response data from backend.');
      }
      setIsSubmitted(true);
    } catch (error) {
      console.error('Error submitting data:', error);
    }
  };
  
  const updateGridData = (data) => {
    const updatedGridData = gridData.map((row, rowIndex) => {
      if (rowIndex > 0) {
        const rowLabel = rowLabels[rowIndex - 1]; 
        
        for (const key in data) {
          if (key.startsWith(rowLabel.replace(' विभक्तिः', ''))) { 
            if (key.endsWith('एक')) {
              row[1] = data[key]; 
            } else if (key.endsWith('द्वि')) {
              row[2] = data[key]; 
            } else if (key.endsWith('बह')) {
              row[3] = data[key]; 
            }
          }
        }
      }
      return row;
    });
  
    console.log('Updated Grid Data:', updatedGridData); 
    setGridData(updatedGridData); 
  };  

  const exportToJpeg = () => {
    const gridElement = document.querySelector('.grid-container');
  
    domtoimage.toJpeg(gridElement, { quality: 0.95 })
      .then(dataUrl => {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'gridData.jpeg';
        link.click();
      })
      .catch(error => {
        console.error('Error capturing grid as JPEG:', error);
      });
  };

  const exportToPdf = () => {
    const gridElement = document.querySelector('.grid-container');
  
    domtoimage.toPng(gridElement)
      .then((dataUrl) => {
        const doc = new jsPDF();
        doc.setFont("helvetica", "normal");
        doc.setFontSize(12);
        const imgProps = doc.getImageProperties(dataUrl);
        const pdfWidth = doc.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        doc.addImage(dataUrl, 'PNG', 10, 20, pdfWidth - 20, pdfHeight);
        doc.save('gridData.pdf');
      })
      .catch((error) => {
        console.error('Error capturing grid as PNG for PDF:', error);
      });
  };
  
  return (
    <Container fluid="md">
      <Row className="justify-content-center mt-0">
        <Col xs="auto" className="text-center">
          <h2 className='praatipadikam-heading'>अकारान्त प्रातिपदिकम</h2>
        </Col>
        </Row>  
      <Row className='justify-content-center mt-3'>
        <textarea
          value={praatipadikam} 
          onChange={(e) => setPraatipadikam(e.target.value)} 
          className='form-control text-area-vibhakti'
          rows="1"
        />   
        <input
          className='mt-1'

          id='display-button'
          type='submit'
          value='Submit'
          onClick={handleSubmit} 
          style={{ width: '170px', height: '30px', marginLeft: '20px' }}
        />
      </Row>
      <Row className='mt-3 ms-3 text-start'>
        <h3 className='vibhakti-heading'>विभक्तिः</h3>

      </Row>
      <div className="grid-container">
        {gridData.map((row, rowIndex) => (
          <div key={rowIndex} className="grid-row">
            {row.map((col, colIndex) => (
              <div key={`${rowIndex}-${colIndex}`} className="grid-item">
                {rowIndex > 0 && colIndex >= 1 ? (
                  <textarea
                    value={gridData[rowIndex][colIndex]}
                    className="form-control text-area"
                    rows="1"
                    style={{ width: '80%' }}
                  />
                ) : (
                  col
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className='d-flex justify-content-center mb-5'>
        <input
          className='mt-1 shabdaadhikaaraha-button'
          id='display-button'
          type='submit'
          value='Export as JPEG'
          onClick={exportToJpeg} 
          style={{ width: '170px', height: '30px', marginLeft: '20px' }}
          disabled={!isSubmitted}
        />
        <input
          className='mt-1 shabdaadhikaaraha-button'
          id='display-button'
          type='submit'
          value='Export as PDF'
          onClick={exportToPdf} 
          style={{ width: '170px', height: '30px', marginLeft: '20px' }}
          disabled={!isSubmitted}
        />
      </div>
    </Container>
  );
};

export default Shabdaadhikaaraha;
